export const createMentionMutation = /* GraphQL */ `
  mutation CreateMention($input: CreateMentionInput!) {
    createMention(input: $input) {
      createdAt
    }
  }
`

export const onCreateMentionQuery = /* GraphQL */ `
  subscription OnCreateMention($userMentionsId: ID!) {
    onCreateMention(filter: { userMentionsId: { eq: $userMentionsId } }) {
      id
      createdAt
      userMentionsId
      messageMentionsId
    }
  }
`
